import React, { useRef, useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import Chip from '@material-ui/core/Chip';
import CircleIcon from '@material-ui/icons/FiberManualRecord';

const DetailsCard = props => {
  return (
    <Card className='tb-details-info'>
        {(props.stationData && props.stationData.status && props.stationData.status == 'active')?<Chip icon={<CircleIcon />} className='tb-status-lb-active' label="Active" />:<Chip icon={<CircleIcon />} className='tb-status-lb-inactive' label="Inactive" />}    
        <Grid container>
            <Grid item style={{width:'144px',marginRight:'16px'}}> 
                <Grid item xs={12}>County</Grid>
                <Grid item xs={12} className='tb-row-data' title={(props.stationData && props.stationData.fips_county_code && props.stationData.fips_county_code.length > 20) ? props.stationData.fips_county_code : null}>
                                {(props.stationData && props.stationData.fips_county_code)?
                                    props.stationData.fips_county_code.length > 20 ? props.stationData.fips_county_code.substring(0, 19)+'...' : props.stationData.fips_county_code
                                :'--'}
                </Grid>
                <Grid item xs={12}>Jurisdiction</Grid>
                <Grid item xs={12} className='tb-row-data' 
                                title={(props.stationData && props.stationData.Jurisdiction_name && props.stationData.Jurisdiction_name.length > 20) ? props.stationData.Jurisdiction_name : null}>
                                {(props.stationData && props.stationData.Jurisdiction_name)?
                                    props.stationData.Jurisdiction_name.length > 20 ? props.stationData.Jurisdiction_name.substring(0, 19)+'...' : props.stationData.Jurisdiction_name
                                :'--'}
                </Grid>                       
            </Grid>
            <Grid item style={{width:'88px',marginRight:'16px'}}> 
                <Grid item xs={12}>Latitude</Grid>
                <Grid item xs={12} className='tb-row-data'>{(props.stationData && props.stationData.latitude)?parseFloat(props.stationData.latitude).toFixed(6):'--'}</Grid>                        
                <Grid item xs={12}>Community</Grid>
                <Grid item xs={12} className='tb-row-data'>{(props.stationData && props.stationData.community)?props.stationData.community:'--'}</Grid>
            </Grid>
            <Grid item style={{width:'88px'}}>                        
                <Grid item xs={12}>Longitude</Grid>
                <Grid item xs={12} className='tb-row-data'>{(props.stationData && props.stationData.longitude)?parseFloat(props.stationData.longitude).toFixed(6):'--'}</Grid>
                <Grid item xs={12}>Speed limit</Grid>
                <Grid item xs={12} className='tb-row-data'>{(props.stationData && props.stationData.speed_limit)?props.stationData.speed_limit:'--'}</Grid>
            </Grid>
        </Grid>
    </Card>
  )  
}

export default DetailsCard;